import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "chat-export-mobile"
};
const _hoisted_2 = {
  class: "chat-box"
};
const _hoisted_3 = {
  class: "chat-list-wrapper"
};
const _hoisted_4 = {
  id: "message-list-box",
  class: "message-list-box"
};
import { dateFormat, processContent } from "@/utils/libs";
import ChatReply from "@/components/mobile/ChatReply.vue";
import ChatPrompt from "@/components/mobile/ChatPrompt.vue";
import { nextTick, ref } from "vue";
import { useRouter } from "vue-router";
import { httpGet } from "@/utils/http";
import 'highlight.js/styles/a11y-dark.css';
import hl from "highlight.js";
import { showFailToast } from "vant";
export default {
  __name: 'ChatExport',
  setup(__props) {
    const chatData = ref([]);
    const router = useRouter();
    const chatId = router.currentRoute.value.query['chat_id'];
    const title = ref('');
    const role = ref('');
    const model = ref('');
    const finished = ref(false);
    const error = ref(false);
    const mathjaxPlugin = require('markdown-it-mathjax3');
    const md = require('markdown-it')({
      breaks: true,
      html: true,
      linkify: true,
      typographer: true,
      highlight: function (str, lang) {
        const codeIndex = parseInt(Date.now()) + Math.floor(Math.random() * 10000000);
        // 显示复制代码按钮
        const copyBtn = `<span class="copy-code-mobile" data-clipboard-action="copy" data-clipboard-target="#copy-target-${codeIndex}">复制</span>
<textarea style="position: absolute;top: -9999px;left: -9999px;z-index: -9999;" id="copy-target-${codeIndex}">${str.replace(/<\/textarea>/g, '&lt;/textarea>')}</textarea>`;
        if (lang && hl.getLanguage(lang)) {
          const langHtml = `<span class="lang-name">${lang}</span>`;
          // 处理代码高亮
          const preCode = hl.highlight(lang, str, true).value;
          // 将代码包裹在 pre 中
          return `<pre class="code-container"><code class="language-${lang} hljs">${preCode}</code>${copyBtn} ${langHtml}</pre>`;
        }

        // 处理代码高亮
        const preCode = md.utils.escapeHtml(str);
        // 将代码包裹在 pre 中
        return `<pre class="code-container"><code class="language-${lang} hljs">${preCode}</code>${copyBtn}</pre>`;
      }
    });
    md.use(mathjaxPlugin);
    const onLoad = () => {
      httpGet('/api/chat/history?chat_id=' + chatId).then(res => {
        // 加载状态结束
        finished.value = true;
        const data = res.data;
        if (data && data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            if (data[i].type === "prompt") {
              chatData.value.push(data[i]);
              continue;
            }
            data[i].orgContent = data[i].content;
            data[i].content = md.render(processContent(data[i].content));
            chatData.value.push(data[i]);
          }
          nextTick(() => {
            hl.configure({
              ignoreUnescapedHTML: true
            });
            const blocks = document.querySelector("#message-list-box").querySelectorAll('pre code');
            blocks.forEach(block => {
              hl.highlightElement(block);
            });
          });
        }
      }).catch(() => {
        error.value = true;
      });
      httpGet(`/api/chat/detail?chat_id=${chatId}`).then(res => {
        title.value = res.data.title;
        model.value = res.data.model;
        role.value = res.data.role_name;
      }).catch(e => {
        showFailToast('加载对话失败：' + e.message);
      });
    };
    return (_ctx, _cache) => {
      const _component_van_cell = _resolveComponent("van-cell");
      const _component_van_dropdown_item = _resolveComponent("van-dropdown-item");
      const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu");
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      const _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_nav_bar, {
        "left-arrow": "",
        "left-text": "返回",
        onClickLeft: _cache[0] || (_cache[0] = $event => _unref(router).back())
      }, {
        title: _withCtx(() => [_createVNode(_component_van_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_van_dropdown_item, {
            title: title.value
          }, {
            default: _withCtx(() => [_createVNode(_component_van_cell, {
              center: "",
              title: "角色"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(role.value), 1)]),
              _: 1
            }), _createVNode(_component_van_cell, {
              center: "",
              title: "模型"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(model.value), 1)]),
              _: 1
            })]),
            _: 1
          }, 8, ["title"])]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_van_list, {
        error: error.value,
        "onUpdate:error": _cache[1] || (_cache[1] = $event => error.value = $event),
        finished: finished.value,
        "error-text": "请求失败，点击重新加载",
        onLoad: onLoad
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chatData.value, item => {
          return _openBlock(), _createBlock(_component_van_cell, {
            key: item,
            border: false,
            class: "message-line"
          }, {
            default: _withCtx(() => [item.type === 'prompt' ? (_openBlock(), _createBlock(ChatPrompt, {
              key: 0,
              content: item.content,
              "created-at": _unref(dateFormat)(item['created_at']),
              icon: item.icon,
              tokens: item['tokens']
            }, null, 8, ["content", "created-at", "icon", "tokens"])) : item.type === 'reply' ? (_openBlock(), _createBlock(ChatReply, {
              key: 1,
              content: item.content,
              "created-at": _unref(dateFormat)(item['created_at']),
              icon: item.icon,
              "org-content": item.orgContent,
              tokens: item['tokens']
            }, null, 8, ["content", "created-at", "icon", "org-content", "tokens"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }, 8, ["error", "finished"])])])])]);
    };
  }
};